<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="8">
                <v-card class="elevation-12">
                    <v-toolbar color="secondary" flat dense>
                        <v-toolbar-title>Reset Stock</v-toolbar-title>
                    </v-toolbar>

                    <v-card-text>
                        <v-row class="justify-center align-center">
                            <v-col cols="12">
                                <span style="color: red; font-size: 18px"> Enter email and password to reset data, Please note this action is irreversible !!!</span>
                            </v-col>
                            <v-col cols="12" md="6">
                               
                                <v-form ref="resetForm" v-model="valid" :lazy-validation="lazy">
                                    <v-text-field label="Email" v-model="user.email" :rules="inputRules"
                                        prepend-icon="mdi-account-outline" type="text" />

                                    <v-text-field id="password" label="Password" name="password" v-model="user.password"
                                        :rules="inputRules" autocomplete="on" prepend-icon="mdi-lock"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword" />
                                </v-form>
                                <v-row no-gutters class="mt-2">
                                    <v-btn :loading="loader" color="primary" class="right" @click="resetStock"><v-icon
                                            left>mdi-lock-reset</v-icon>Reset Data</v-btn>
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn color="accent" to="/register" text>Or Register</v-btn> -->
                                </v-row>

                                <!-- <v-row class="pt-3">
                    <v-btn color="primary" text small to="/reset/password">Forgot password? Reset</v-btn>
                  </v-row>-->
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions></v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- start of snackbar -->
        <snackbar ref="snackbar"></snackbar>
        <!-- end of snackbar -->
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            lazy: false,
            valid: false,
            user: {},
            loader: false,
            showPassword: false,
            inputRules: [v => !!v || "Required"],
            emailRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+\..+/.test(v) || "E-mail must be valid"
            ]
        };
    },
    computed: {
        storeName() {
            return localStorage.getItem("storeName");
        }
    },
    methods: {
        resetStock() {
            var storeId = localStorage.getItem("store_id");
            if (this.$refs.resetForm.validate()) {
                const url = `/reset-stock-data/${storeId}`;
                var data = this.user;
                data.store_id = parseInt(storeId);
                const self = this;
                self.loader = true;
                this.$store
                    .dispatch("post", { url, data })
                    .then(res => {
                        if (res.ResultCode == 1200) {
                            self.user = {};
                            self.loader = false;
                            self.$refs.snackbar.show(" Stock reset successful", "green");
                        } else {
                            self.loader = false;
                            this.$refs.snackbar.show(res.ResultDesc, "red");
                        }
                    })
                    .catch(err => {
                        self.loader = false;
                        this.$refs.snackbar.show(err, "red");
                    });
            }
        },
    },
    created() {

    }
};
</script>

<style lang="scss" scoped></style>